import React from "react"
import styled from "@emotion/styled"
import { Link, useStaticQuery, graphql } from "gatsby";
import theme from "../theme";
import * as JsSearch from 'js-search';
import {
  Box,
  Text,
  Input,
  PseudoBox,
} from "@chakra-ui/core"
import moment from "moment"

const Styles = styled.div``

class Component extends React.Component {
  constructor(props) {
    super()
    this.state = {}
    this.state.results = []

  }

  componentDidMount() {
    var search = new JsSearch.Search('id');
    search.addIndex('title');
    search.addIndex('phenotypeInfo');
    search.addIndex('cross');
    search.addIndex(['body', 'body']);
    search.addDocuments(this.props.search)
    this.setState({ search })
  }


  onChange(e) {
    let results = this.state.search.search(e.currentTarget.value);
    this.setState({ results })
  }

  result(el) {
    switch (el.internal.type) {
      case "ContentfulCatalog":
        return <Link to={"catalog/" + el.slug} key={el.slug}>
        <PseudoBox position="relative"zIndex="400" rounded="md" transition="0.1s ease" _hover={{ bg: "gray.100", transform: "scale(1.03)" }} p={"3px 6px"}>
          {el.title}
          <Text fontSize="10px" color={"blue.700"}>(${el.price.toFixed(2)})</Text>
        </PseudoBox>
        </Link>
        break;
        case "ContentfulStore":
        return <Link to={"store/" + el.slug} key={el.slug}>
        <PseudoBox position="relative"zIndex="400" rounded="md" transition="0.1s ease" _hover={{ bg: "gray.100", transform: "scale(1.03)" }} p={"3px 6px"}>
          {el.title}
          <Text fontSize="10px" color={"green.700"}>(${el.price.toFixed(2)})</Text>
        </PseudoBox>
        </Link>
        break;
        case "ContentfulBlog":
        return <Link to={"blog/" + el.slug} key={el.slug}>
        <PseudoBox position="relative"zIndex="400" rounded="md" transition="0.1s ease" _hover={{ bg: "gray.100", transform: "scale(1.03)" }} p={"3px 6px"}>
          {el.title}
          <Text fontSize="10px" color={"red.700"}>{moment(el.createdAt).format("LL")}</Text>

        </PseudoBox>
        </Link>
        break;
      default:
        break;
    }
    

  }

  resetResults() {
    setTimeout(this.resetResults2.bind(this), 300);

  }

  resetResults2() {
    this.setState({
      results: []
    })
  }

  render() {
    return (
      <Styles>
        <Box position="relative" zIndex="1000">

          <Input size="sm" onChange={this.onChange.bind(this)} bg={theme.white} rounded="md" placeholder="🔍 Search" width={["120px", "200px"]} onBlur={this.resetResults.bind(this)} borderColor="gray.900" />
          <Box top="40px" zIndex="10000" rounded="md" position="absolute" bg={"white"} minWidth="200px">
            {
              this.state.results.map(this.result.bind(this))
            }
          </Box>
        </Box>

      </Styles>
    )
  }
}


export default () => {
  const { catalog, store, blog } = useStaticQuery(
    graphql`
        {
            catalog: allContentfulCatalog {
                nodes {
                  id
                  body {
                    body
                  }
                  title
                  price
                  slug
                  phenotypeInfo
                  cross
                  internal {
                    type
                  }
                }

                
              }

              store: allContentfulStore {
                nodes {
                  id
                  body {
                    body
                  }
                  title
                  price
                  slug
                  internal {
                    type
                  }
                }
              }
              
              blog: allContentfulBlog(sort: {fields: createdAt, order: ASC}) {
                nodes {
                  id
                  title
                  slug
                  createdAt

                  search {
                    search
                  }

                  internal {
                    type
                  }
          
                }
              }

             
          
        }
      `
  )
  return <Component search={catalog.nodes.concat(blog.nodes).concat(store.nodes)} />
}